import { AutoMap } from '@automapper/classes';

export class GlobalTaskEntity {
    Id?: number;
    @AutoMap()
    Position!: number;
    @AutoMap()
    Description!: string;
}
